module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.provider.showLogo === true) ? _c('div', {
    staticClass: "provider-accreditation"
  }, [_vm._v("\n  " + _vm._s(_vm.$t('message.labelProviderInAssociationWith')) + "\n  "), _vm._m(0), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.$store.state.provider.logo
    }
  })]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nhs-logo"
  }, [_c('img', {
    attrs: {
      "src": "static/nhs-logo.svg",
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-52c8851d","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Provider/Provider.vue
// module id = 3727
// module chunks = 1